'use client';

import { UserAvatar } from './UserAvatar';

interface UserMenuHeaderProps {
  /** User's full name. */
  displayName: string;
  /** User's email address. */
  email?: string | undefined;
  /** Optional profile image URL. */
  imageUrl?: string | undefined;
}

/**
 * Header section for user menu dropdowns.
 * Shows avatar + name + email in a compact layout.
 */
export function UserMenuHeader({
  displayName,
  email,
  imageUrl,
}: UserMenuHeaderProps) {
  return (
    <div className='flex items-center gap-3 px-2 py-2'>
      <UserAvatar displayName={displayName} imageUrl={imageUrl} size='lg' />
      <div className='flex flex-col min-w-0'>
        <p className='text-sm font-medium text-content-primary truncate'>
          {displayName}
        </p>
        {email && (
          <p className='text-xs text-content-muted truncate'>{email}</p>
        )}
      </div>
    </div>
  );
}
